import { createSelector } from '@reduxjs/toolkit';
import { getWelcomeMessage } from '../../selectors/widgetDataSelectors/getWelcomeMessage';
import { getGates, getLanguage, getSearchableKnowledgeBaseIds as getSearchableKnowledgeBaseIdsOperator } from '../operators/widgetDataGetters';
import { getLatestWidgetData } from './getLatestWidgetData';
export const getWidgetDataLanguage = createSelector(getLatestWidgetData, widgetData => getLanguage(widgetData));
export const getSearchableKnowledgeBaseIds = createSelector(getWelcomeMessage, welcomeMessage => getSearchableKnowledgeBaseIdsOperator(welcomeMessage));
export const getWidgetDataGates = createSelector(getLatestWidgetData, widgetData => getGates(widgetData));

/* validates a single gate or multiple gates */
export const createGateSelectorFromGateNames = (...gateNames) => createSelector([getWidgetDataGates], gates => gateNames.every(key => (gates === null || gates === void 0 ? void 0 : gates[key]) === true || (gates === null || gates === void 0 ? void 0 : gates[key]) === 'true'));

/**
 * Checks if portal is ungated for KB in widget which is
 * also dependent on the updated UI gate.
 */
export const getIsUngatedForKBInWidget = createGateSelectorFromGateNames('Conversations:KBInWidget');
export const getIsUngatedForChatTransfer = createGateSelectorFromGateNames('Conversations:TransferState');